import { render, staticRenderFns } from "./BankDetails.vue?vue&type=template&id=0a3d1841&scoped=true"
import script from "./BankDetails.vue?vue&type=script&lang=ts"
export * from "./BankDetails.vue?vue&type=script&lang=ts"
import style0 from "./BankDetails.vue?vue&type=style&index=0&id=0a3d1841&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3d1841",
  null
  
)

export default component.exports